var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "vuesax/outline/message-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.411 21.168H4.324a1.5 1.5 0 01-1.492-1.493V8.589c0-3.77 1.987-5.757 5.757-5.757h6.823c3.77 0 5.757 1.987 5.757 5.757v6.823c-.001 3.769-1.988 5.756-5.758 5.756zM8.589 4.111c-3.057 0-4.478 1.421-4.478 4.478v11.086a.211.211 0 00.213.213h11.087c3.053 0 4.477-1.424 4.477-4.477V8.589c0-3.053-1.424-4.477-4.477-4.477z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M8.5 12h7M15.5 12.75h-7a.755.755 0 01-.75-.75.755.755 0 01.75-.75h7a.755.755 0 01.75.75.755.755 0 01-.75.75zM12 15.5v-7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M12 16.25a.755.755 0 01-.75-.75v-7a.755.755 0 01.75-.75.755.755 0 01.75.75v7a.755.755 0 01-.75.75z"
  }))));
}
export default SvgVuesaxOutlineMessageAdd;